import React from 'react';
import { AnimatedLayoutText } from '../../utils/customStyles';
import { AnimatedWords } from './animateStyle';

const AnimatedLayout = ({ letterClass, strArray, idx }) => {
  return (
    <AnimatedWords>
      {strArray.map((char, i) => (
        <AnimatedLayoutText
          key={char + i}
          letterClass={letterClass}
          aria-hidden='true'
          delayCount={i + idx}
        >
          {char}
        </AnimatedLayoutText>
      ))}
    </AnimatedWords>
  );
};

export default AnimatedLayout;
